// Controls
import { LeftNavOption } from "./LeftNavOption";
// Icons
import { Info } from "@ms/planner-generic-controls/lib/local/icons/index";
// Resources
import { Strings } from "../../../utilities/CultureUtilities";
// Styles
import { useLeftNavPinnedSectionStyles } from "./LeftNavPinnedSection.styles";
// Utilities
import { mergeClasses, useArrowNavigationGroup } from "@fluentui/react-components";
import * as React from "react";
/**
 * LeftNav component for rendering pinned section
 */ export const LeftNavPinnedSection = ({ pinnedOptions, isLeftNavCollapsed, keyCodeMapper, shouldRenderPinnedError, onRetryButtonClicked })=>{
    const styles = useLeftNavPinnedSectionStyles();
    const arrowNavigationAttributes = useArrowNavigationGroup({
        axis: "vertical",
        memorizeCurrent: false
    });
    const renderErrorPinnedSectionState = ()=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.errorPinnedSectionContent
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.errorMessage
        }, /*#__PURE__*/ React.createElement(Info, null), /*#__PURE__*/ React.createElement("span", null, Strings.LeftNav_ErrorPinnedSectionText)), /*#__PURE__*/ React.createElement("button", {
            className: styles.retryButton,
            onClick: onRetryButtonClicked
        }, Strings.LeftNav_ErrorPinnedSectionRetryButtonText));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeClasses(styles.root, isLeftNavCollapsed && styles.rootCollapsed),
        ...arrowNavigationAttributes
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.pinnedSectionHeader
    }, Strings.LeftNav_PinnedText), /*#__PURE__*/ React.createElement("div", {
        className: styles.pinnedSectionContainer,
        role: "region",
        "aria-label": Strings.LeftNav_PinnedText,
        tabIndex: 0
    }, shouldRenderPinnedError ? renderErrorPinnedSectionState() : pinnedOptions.length === 0 ? /*#__PURE__*/ React.createElement("div", {
        className: styles.emptyPinnedSectionContent
    }, Strings.LeftNav_EmptyPinnedSectionText) : /*#__PURE__*/ React.createElement("ul", {
        className: styles.leftNavOptionsList,
        role: "menubar"
    }, pinnedOptions.map((option, index)=>/*#__PURE__*/ React.createElement(LeftNavOption, {
            ...option,
            key: option.id || index.toString(),
            keyCodeMapper: keyCodeMapper,
            ariaPosInSet: index + 1,
            ariaSetSize: pinnedOptions.length
        })))));
};
